import { render } from "./ListeServicePage.vue?vue&type=template&id=3b9aab47&ts=true"
import script from "./ListeServicePage.vue?vue&type=script&lang=ts"
export * from "./ListeServicePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__